import un from 'underscore'
function getBaseUrl() {
  if (process.env.NODE_ENV === 'production')
    return "https://api.torregsm.pl";
  if (process.env.NODE_ENV === 'demo')
    return "https://api.torre.wojnowski.cloud";
  if (process.env.NODE_ENV === 'demo-gsm')
    return "https://api.demo.gsm365.pl";
  return "http://localhost:8080";
}
export default {
  baseUrl: getBaseUrl(),
  statuses: function(isAdmin) {
    if (isAdmin) {
        return [
          { id: 1, text: "dostępny" },
          { id: 2, text: "zamówiony" },
          { id: 3, text: "wyprzedany" },
          { id: 4, text: "nie dotyczy" },
          { id: 5, text: "brak towaru" },
        ]
    } else {
      return [
        { id: 1, text: "dostępny" },
        { id: 2, text: "zamówiony" },
        { id: 3, text: "wyprzedany" },
        { id: 4, text: "nie dotyczy" },
      ]
    }
  },
  filterStatuses: [
    { id: 0, text: "wszystkie" },
    { id: 1, text: "dostępny" },
    { id: 2, text: "zamówiony" },
    { id: 3, text: "wyprzedany" },
    { id: 5, text: "brak towaru" },
  ],
  editableStatuses: function(isAdmin) {
    if (isAdmin) {
        return [
          { id: 1, text: "dostępny" },
          { id: 2, text: "zamówiony" },
          { id: 3, text: "wyprzedany" },
          { id: 5, text: "brak towaru" },
        ];
    } else {
      return [
        { id: 1, text: "dostępny" },
        { id: 2, text: "zamówiony" },
        { id: 3, text: "wyprzedany" },
        { id: 5, text: "brak towaru" },
      ]
    }
  },
  editableStatusesClass: {
    1: "availabile-class",
    2: "ordered-class",
    3: "sold-out-class",
    4: "not-included-class",
    5: "no-sku-available-class"
  },
  pageableMainParams: {
    "page": 0,
    "size": 60,
    "sort": "name,desc"
  },
  defaultQueryParams: {
    "size": 2500,
    "sort": "name,asc"
  },
  getTextForStatus: function(id) {
    return un.findWhere(this.statuses(true), {id: id}).text;
  },
  getClassForStatus: function(id) {
    return this.editableStatusesClass[id];
  }
}



// WEBPACK FOOTER //
// ./src/service/config.js